<script setup lang="ts">
defineProps<{
  currentPage: number
  hasNextPage: boolean
  hasPreviousPage: boolean
}>()

const emit = defineEmits<{
  (event: 'move-to-next-page'): void
  (event: 'move-to-previous-page'): void
}>()
</script>

<template>
  <div :class="$style.content">
    <button
      :class="$style.button"
      :disabled="!hasPreviousPage"
      @click="emit('move-to-previous-page')"
    >
      &lt;
    </button>
    <div :class="$style.num">{{ currentPage + 1 }}</div>
    <button
      :class="$style.button"
      :disabled="!hasNextPage"
      @click="emit('move-to-next-page')"
    >
      &gt;
    </button>
  </div>
</template>

<style module lang="scss">
.content {
  display: flex;
  align-items: center;
  gap: 12px;
}

.num {
  font-weight: bold;
}

.button {
  font-size: 16px;
  text-decoration: underline;

  &:disabled {
    color: $color-text-and-object-low-emphasis;
    cursor: default;
    text-decoration: none;
  }
}
</style>
